import AuthLeftPanel from '@/components/AuthLeftPanel'
import Loader from '@/components/Loader'

const LoginLoading = () => (
  <div className="flex max-tablet-p:flex-col max-tablet-p:min-h-screen tablet-p:min-h-screen">
    <AuthLeftPanel />
    <div className="bg-white flex items-center shrink-0 w-[40%] py-10 px-25 max-tablet-p:flex-1 max-tablet-p:justify-center max-tablet-p:w-full max-tablet-p:p-5">
      <div className="max-w-100 flex flex-col w-full gap-10">
        <div className="flex flex-col items-center justify-center gap-4 py-12">
          <Loader />
          <p className="type-body-2 text-grey-50">Looking up your submittal&hellip;</p>
        </div>
      </div>
    </div>
  </div>
)

export default LoginLoading
